export default __webpack_public_path__ + "f19ed8a910ef82d084ef9294749eed7f.svg";